// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__fjTwV","wrapperActive":"Header_wrapperActive__AJ++H","header":"Header_header__0a2kf","logo":"Header_logo__dfnbu"};